import { inject, observer } from 'mobx-react'
import styled from '@emotion/styled'

import { withRouterProps } from '../../utils/wrappers'
import heyNicBubble from '../../assets/images/heyNicBubbleDefault.png'
import heyNicBubbleHover from '../../assets/images/heyNicBubbleHover.png'

// Mobile-only entry point shown under the Home alerts component. Tapping the
// Hey Nic chat bubble opens the global chatbot. (Desktop uses the top nav.)
const Bubble = styled.button`
  display: none;

  @media (max-width: 800px) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: 35px;
    padding: 0;
    border: none;
    background: none;
    cursor: pointer;
  }

  & img {
    display: block;
    height: 45px;
    width: auto;
  }
  /* Swap to the hover artwork while the bubble is pressed. */
  & .hey-nic-hover {
    display: none;
  }
  &:active .hey-nic-default {
    display: none;
  }
  &:active .hey-nic-hover {
    display: block;
  }
`

const HomeHeyNicBubble = ({ store, navigate, location }) => {
  if (!store.features?.enableHeyNic || !store.aiStatus?.available) return null

  return (
    <Bubble
      type='button'
      onClick={() => navigate('/hey-nic', { state: { from: location?.pathname ?? '/home' } })}
      aria-label='Open Hey Nic'>
      <img src={heyNicBubble} className='hey-nic-default' alt='Hey Nic AI' />
      <img src={heyNicBubbleHover} className='hey-nic-hover' alt='' />
    </Bubble>
  )
}

export default withRouterProps(inject('store')(observer(HomeHeyNicBubble)))
